export var LoadingAnimationType;
(function (LoadingAnimationType) {
    LoadingAnimationType["FluentSpinner"] = "FluentSpinner";
    LoadingAnimationType["Donut"] = "Donut";
    LoadingAnimationType["VerticalBar"] = "VerticalBar";
    LoadingAnimationType["HorizontalBar"] = "HorizontalBar";
    LoadingAnimationType["Line"] = "Line";
    LoadingAnimationType["Shimmer"] = "Shimmer";
})(LoadingAnimationType || (LoadingAnimationType = {}));
export var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["notLoading"] = 0] = "notLoading";
    LoadingState[LoadingState["loading"] = 1] = "loading";
    LoadingState[LoadingState["hidingLoading"] = 2] = "hidingLoading";
})(LoadingState || (LoadingState = {}));
//# sourceMappingURL=loading-pane.types.js.map